export default __webpack_public_path__ + "images/553336ec2a69740487f693d892be4ae9-certificate.svg";